var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "memorandum_info" }, [
    _c(
      "div",
      { staticClass: "tender_data" },
      [
        _c("legend", [
          _vm._v("\n            Протокол засідання тендерної комісії "),
          _c("br"),
          _vm._v(
            "\n            з проведення процедури розгляду тендерних пропозицій № " +
              _vm._s(_vm.tender_number_field.counterparty) +
              "\n        "
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "before_change" }, [
          _vm.draw_items.length > 0
            ? _c(
                "table",
                {
                  staticClass: "table",
                  staticStyle: { "border-collapse": "collapse" },
                },
                [
                  _c("thead", [
                    _c("tr", [
                      _c(
                        "th",
                        {
                          staticClass: "bold",
                          attrs: { colspan: _vm.head_items.length },
                        },
                        [
                          _vm._v(
                            "\n                            ПРОПОЗИЦІЇ*\n                        "
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "tr",
                      _vm._l(_vm.head_items, function (head) {
                        return _c("th", { staticClass: "field_head" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(head.name) +
                              "\n                        "
                          ),
                        ])
                      }),
                      0
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    _vm._l(_vm.draw_items, function (field) {
                      return _c("tender_field", {
                        key: "drw_" + field.id,
                        attrs: { field: field },
                        on: { click_item: _vm.show_info },
                      })
                    }),
                    1
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "prim" }, [
            _vm._v(" *Детальна пропозиція - у додатках"),
          ]),
          _vm._v(" "),
          _c("legend", { staticClass: "mt-5" }, [_vm._v("Переможець тендеру")]),
          _vm._v(" "),
          _vm.winner_items.length > 0
            ? _c(
                "div",
                { staticClass: "fields_insert row-fluid" },
                _vm._l(_vm.winner_items, function (winner) {
                  return _c(
                    "div",
                    [
                      _c(
                        "b-row",
                        { staticClass: "mem_text position-relative" },
                        [
                          _c(
                            "b-col",
                            {
                              staticClass: "position-relative",
                              attrs: { sm: "3" },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "cursor-pointer fs-xl text-center",
                                  on: {
                                    click: function ($event) {
                                      return _vm.show_info(winner)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(winner.org_name) +
                                      "\n                            "
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            {
                              staticClass: "position-relative",
                              attrs: { sm: "9" },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "text_winner" },
                                [
                                  _c("mem_text", {
                                    key: "winner",
                                    attrs: {
                                      show_label: false,
                                      label: "Переможець тендеру",
                                      text: winner.payment,
                                    },
                                    on: {
                                      edit_text: function ($event) {
                                        return _vm.edit_winner(winner)
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
                0
              )
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("company_info"),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }